<template>
    <div class="codelab-tool-bar">
        <template v-if="moreToolIs">
            <template v-for="(o, index) in toolbars">
                <span :class="[ o.class, handleAllowToSave(o.fn) && shit$(`cursor:not-allowed;`) ]" :title="$t(o.title)" @click="handleFn(o.fn)" :key="index + o.href">
                    <svg-icon :shit="handleSvgStyle(o)" :href="o.href" :width="o.width" :height="o.height"></svg-icon>
                </span>
            </template>
            <el-dropdown
                trigger="click"
                @command="moreDropCommand"
                :hide-on-click="true" 
                placement="bottom-start"
                class="more-tool">
                    <span class="tool-item" :title="$t('more')">
                        <svg-icon href="#codelab-icon-more" width="20" height="20"></svg-icon>
                    </span>
                    <el-dropdown-menu class="codelab-dropdown more-func-dropdown" slot="dropdown">
                        <li class="title">{{$t("more_function")}}</li>
                        <!-- <el-dropdown-item class="drop-item" command="showTrigger"><span :class="shit$(`ml:15px;`)">{{$t("robot_trigger_setting")}}</span></el-dropdown-item> -->
                        <el-dropdown-item class="drop-item" command="showCode"><span :class="shit$(`ml:15px;`)">{{$t("show_gen_code")}}</span></el-dropdown-item>
                    </el-dropdown-menu>
            </el-dropdown>
            <span class="split"></span>
        </template>

        <span class="project-info">
            <div class="project-name" :class="!isAllowSave && shit$(`color:rgba(255, 255, 255, .5)!;`)">
                {{ (this.strSliceStarAndEndT(projectData.name, 34, 26) || $t('UNNAMEDPROJECT')) + '.xml' }}
                <template v-if="!isSaved && !isPublicVersion && isAllowSave">
                    <span>
                        ({{$t("unsaved_program")}})
                    </span>
                </template>
            </div>
        </span>

        <section class="connectDeviceClass">
              <play-button></play-button>
            <device-manage></device-manage>
        </section>

        <popper-edit-project 
            :mode="editProjectMode"
            :title="editProjectTitle"
            v-if="showEditProjectPoper"
            @close="closePopperEditproject"
            @confirm="confirmPopperEditproject"
        ></popper-edit-project>

        <quick-connection @handleEventBtn="$store.commit('quickConnection/switchQuickHandler', false)" v-if="switchQuick" :isConnectStatus="switchQuick"></quick-connection>
        <rms-connection v-if="switchRms" :show="switchRms"></rms-connection>
        <set-teach-connnection v-if="switchTeach" :show="switchTeach"></set-teach-connnection>
        <set-device-play v-if="switchSetPlay" :show="switchSetPlay"></set-device-play>
    </div>
</template>

<script>
import popperEditProject from "@/code-lab/component/popper-edit-project.vue";

import buttonConfig from "@/service/mapping/codelab-button-config.js";

import QuickConnection from "@/code-lab/component/connection/quick/quick-cnnection.vue";
import RmsConnection from "@/code-lab/component/connection/rms/rms-connnection.vue";
import SetTeachConnnection from "@/code-lab/component/connection/set-teach-connnection.vue";
import SetDevicePlay from '@/code-lab/component/connection/set-device-play.vue'

import IndexMixGroceryStore from "@/code-lab/component/mixins/indexMixStore.js";
import PublicVersionMix from "@/code-lab/component/mixins/publicVersionMix.js";

import DeviceManage from "@/code-lab/component/robot-connect/device-manage/device-manage.vue";
import PlayButton from '@/code-lab/component/robot-connect/play-button/play-on-robot.vue'

import toolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import saveProjectMix from '@/code-lab/component/mixins/save-project-mix.js'
import catchScreen from "@/code-lab/lib/screen-catcher"

import { mapState } from "vuex";
const Blockly = window.Blockly;
const CONSTS = window.CONSTS;
const { toolbar } = buttonConfig;
export default {
  name: "tool-bar",
  mixins: [IndexMixGroceryStore, PublicVersionMix, toolMix, saveProjectMix],
  components: {
    RmsConnection,
    QuickConnection,
    SetTeachConnnection,
    popperEditProject,
    DeviceManage,
    PlayButton,
    SetDevicePlay
  },
  data() {
    return {
      script: "",
      connectMode: "",
      toolbars: toolbar,
      editProjectMode: "",
      showEditProjectPoper: false,
      showCloseSocketButton: false
    };
  },
  computed: {
    ...mapState({
      isSaved: "isSaved",
      showCode: "showCode",
      workSpace: "workSpace",
      isAllowSave: "isAllowSave",
      projectData: "projectData",
      selectedMenue: "selectedMenue",
      currentVersion: "currentVersion",
      currentMission: 'currentMission',
      isCloudProject: 'isCloudProject',
      connectGolbalState: "connectGolbalState"
    }),
    ...mapState("quickConnection", ["switchQuick"]),
    ...mapState("teachConnection", { switchTeach: "switch" }),
    ...mapState("setDevicePlay", { switchSetPlay: "switch" }),
    ...mapState("rmsConnection", {
      connectDevices: "connectDevices",
      switchRms: "switch"
    }),
    editProjectTitle() {
      if (this.editProjectMode === "new") {
        return this.$t("LANG_TITLE_TEXT_NEW_FILE");
      } else if (this.editProjectMode === 'another') {
        return this.$t("code-lab/component/layout/toolbar.vue_0")
      } else {
        return this.$t("LANG_TITLE_TEXT_SAVE_FILE");
      }
    },
    projectName() {
      return this.projectData.name
    },
    moreToolIs() {
      return this.computedToolBarHide()
    },
    isPublicVersion() {
      return this.currentVersion === "public"
    }
  },
  methods: {
    async saveDirect (mode = "save") {
      const { name } = this.projectData
      this.editProjectMode = mode;
      await this.saveProjectAndExportExecuteUrl({ name })
      this.saveBlock(this.projectData)
    },
    computedToolBarHide() {
      const mapping = { public: 0, student: 1, family: 1, teacher: 1 }
      return !!mapping[this.currentVersion];
    },
    handleConnectEvent() {
      if (this.connectGolbalState) {
        this.showCloseSocketButton = !this.showCloseSocketButton;
      } else {
        this.showCloseSocketButton = false;
        this.handleQuikeEventBtn(true);
      }
    },
    handleSvgStyle(o) {
      const strOne = this.handleAllowToSave(o.fn) && `fill:rgba(193, 193, 193, .5)!; stroke:rgba(193, 193, 193, .5)!;`
      return strOne || '';
    },
    handleAllowToSave(fnName) {
      const notAllowArr = ["beforSaveBlock", 'beforSaveAnotherBlock'];
      const isAllowSave = this.isAllowSave;
      return notAllowArr.includes(fnName) && !isAllowSave;
    },
    handleFn(fnName) {
      if (this.handleAllowToSave(fnName)) return;
      this[fnName]();
    },
    childClick(msg) {
      this[msg["key"]] = true;
    },
    beforeCreateProject() {
      if (!this.isSaved && this.isAllowSave) {
        this.showUnsavedTips(0)
          .then(() => {
            this.$store.commit("SELECTEDMENUERIGHT", null);
            this.showEditProjectPoper = true;
            this.editProjectMode = "new";
            this.$store.commit("isCloudProject", false)
          })
          .catch(e => {
            if (e === "cancel") {
              setTimeout(() => this.beforSaveBlock(), 400)
            }
          });
      } else {
        this.$store.commit("SELECTEDMENUERIGHT", null);
        this.showEditProjectPoper = true;
        this.editProjectMode = "new";
        this.$store.commit("isCloudProject", false)
      }
    },
    beforSaveAnotherBlock () {
      console.log('beforSaveAnotherBlock')
      this.editProjectMode = 'another';
      this.showEditProjectPoper = true;
    },
    beforSaveBlock () {
      if (!this.currentMission) {
        var xml = Blockly.Xml.workspaceToDom(this.workSpace);
        this.script = Blockly.Xml.domToText(xml)
        if (!this.script) return;
        const saveFn = (saveType = 'save') => {
          this.editProjectMode = saveType;
          this.showEditProjectPoper = true;
        }
        if (!this.isSaved) {
          if(this.projectData.projectId){
            this.saveDirect("save");
            catchScreen("buffer").then(buffer => {
              this.uploadScreenshot(buffer).then(() => {
              });
            });
          } else {
            saveFn()
          }
        }
      } else {
        this.$root.$emit("updateMission")
      }
    },
    uploadScreenshot(buffer){
      return new Promise((resolve, reject) => {
          let projectId = this.projectData.projectId;
          this.b$.send('tool', { "cmd": "upload_project_screenshot", data: { projectId }}, res => {
            let data = res.data;
            if(data.state === "todo"){
                  //准备上传文件
                  let {clientId,sId} = data;
                  this.b$.sendBinary("tool", {
                      from: clientId,
                      to: "server",
                      sId,
                      sourceName: "screenshot.png",
                      destinationName: "screenshot.png",
                      size: buffer.byteLength
                  },buffer).then(() => {
                  }).catch(err => {
                      console.log(err);
                  });
              } else if(data.state === "done"){
                  //上传完成
                  resolve(data.screenshot);
                  console.log("专案截图上传成功");
              } else {
                  //出错
                  reject(new Error("upload failed"));
                  console.error("专案截图上传失败")
              }
          })
      });
    },
    confirmPopperEditproject (project) {
      if (this.editProjectMode === "new") {
        this.newBlock(project);
      } else {
        this.saveBlock(project);
      }
      this.closePopperEditproject();
    },
    
    closePopperEditproject() {
      this.showEditProjectPoper = false;
      this.editProjectMode = "";
    },
    
    newBlock(project) {
      let { name, projectId } = project;
      if (!name) return;
      if (this.currentMission) this.$store.commit("SET_CURRENT_MISSION", null)
      this.$store.commit("UPDATE_PROJECT_DATA", {
        name,
        projectId,
        script: "",
        trigger: "",
        version: "",
        materials: []
      });
      let script = Blockly.Xml.textToDom(CONSTS.EMPTY_WORK_SPACE);
      this.$nextTick(() => {
        Blockly.Xml.hardDomToWorkspace(script, this.workSpace)
        catchScreen("buffer").then(buffer => {
          this.uploadScreenshot(buffer).then(() => {
          });
        });
      })
      setTimeout(() => {
        this.$store.commit("UPDATE_IS_SAVED", true);
      }, 400);
    },
    
    saveBlock(project) {
      let { name } = project;
      if (!name) return;
      this.$store.commit("UPDATE_PROJECT_DATA", {
        name
      });
      setTimeout(() => {
        this.$store.commit("UPDATE_IS_SAVED", true);
      }, 400);
    },
    
    download(content, fileName, contentType) {
      let a = document.createElement("a");
      let file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    },
    
    openFile() {
      if (!this.isSaved && this.isAllowSave) {
        this.showUnsavedTips(1)
          .then(() => {
            this.showEditProjectPoper = true;
            this.editProjectMode = "save";
          })
          .catch(e => {
            e === "cancel" && this.$refs.import.execution();
          });
      } else {
        this.$refs.import.execution();
      }
    },
    moreDropCommand(name) {
      if (name === "showCode") {
        this.toggleShowCode();
      } else if (name === "showTrigger") {
        this.openTriggerSetting();
      }
    },
    
    toggleShowCode() {
      this.$store.commit("SET_SHOW_CODE", !this.showCode);
    },
    openTriggerSetting() {
      console.log("open trigger setting");
    },
    removeStyleOfConnectState() {
      this.connectionList.data.forEach((fo, index) => {
        fo.active$ = "";
        this.$set(this.connectionList.data, index, fo);
      });
    }
  },
};
</script>

<style lang="scss">
.codelab-tool-bar {
  @include WitHetLht(100%, 46px, 46px);
  @include FontMix(0px);
  @include ColorMix(null, $--codelab-primary-black-2);
  @include PositionMix(relative);
  box-shadow: 0 1px 3px 0 $--codelab-primary-black-1;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  z-index: 1997;
  & > span {
    display: inline-block;
    flex: 0 0 auto;
  }
  .tool-item {
    @include WitHetLht(36px, 36px, 36px);
    @include BoxModel(margin, 0, 15, 0, 15);
    text-align: center;
    display: inline-block;
    svg {
      fill: #c1c1c1;
      stroke: #c1c1c1;
    }
    &:hover:not(.codelab-button) {
      border-radius: 4px;
      svg {
        fill: #ffffff;
        stroke: #ffffff;
      }
    }
    &.el-dropdown {
      @include BoxModel(padding, 0, 0, 0, 0);
      .el-dropdown-link {
        display: block;
        @include BoxModel(padding, 0, 26, 0, 26);
      }
    }
  }
  .split {
    @include WitHetLht(2px, 24px, null);
    @include ColorMix(null, $--codelab-primary-black-1);
  }
  .codelab-button {
    @include WitHetLht(auto, 24px, 24px);
    @include FontMix(14px);
    @include BoxModel(padding, 0, 24, 0, 24);
    border-radius: 12px;
    svg {
      fill: #ffffff;
      @include BoxModel(margin, null, 8);
    }
    &.play {
      cursor: default;
    }
    &:hover {
      opacity: 0.4;
    }
    &:active {
      opacity: 0.6;
    }
  }
  .btnClass {
    @include ColorMix(#ffffff, $--codelab-primary-gray-3);
    &:hover {
      opacity: 0.6;
    }
    &:active {
      opacity: 0.8;
    }
  }
  .connected-device-button {
    @include WitHetLht(null, 24px, 24px);
    @include FontMix(12px);
    @include ColorMix(#ffffff, #696969);
    @include BoxModel(padding, 0, 0, 0, 0);
    
    
    box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5);
    font-size: 14px;
    cursor: default;
    .trigger {
      outline: none;
      @include BoxModel(padding, 4, 45, 4, 45);
    }
    
    
    
    
    
    
  }
  .connectDeviceClass {
    @include WitHetLht(null, 100%, null);
    display: flex;
    align-items: center;
    margin-right: 28px;
    .connectButtonClass {
      @include FontMix(14px, 500);
      @include WitHetLht(null, 24px, 1.7);
      @include BoxModel(margin, null, 16);
      border-radius: 13px;
      cursor: default;
      :last-child span {
        outline: none;
        display: block;
        @include BoxModel(padding, 0, 18, 0, 18);
      }
    }
  }
  .project-info {
    flex: 1 1 auto;
    padding: 0 14px;
    .project-name {
      height: 100%;
      line-height: 46px;
      font-size: 12px;
      color: #ffffff;
      text-align: left;
      font-weight: 600;
      white-space: nowrap;
      & > span {
        margin-left: 10px;
      }
      .mission-nav {
        .mission-nav-divider {
          margin-left: 10px;
          color: #1bd3ff;
        }
        &:last-child {
          .mission-nav-divider {
            display: none;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.codelab-tool-bar .codelab-undo:active svg {
  fill: #2b8599;
}
.codelab-tool-bar .codelab-redo:active svg {
  fill: #2b8599;
}
.el-dropdown-menu.codelab-dropdown.more-func-dropdown {
  background: $--codelab-primary-black-1;
  border: 1px solid $--codelab-primary-gray-3;
  border-radius: 8px;
  &[x-placement^=bottom]{
    margin-top: -8px;
    .popper__arrow{
      border-bottom-color:$--codelab-primary-gray-3;
      &::after{
        border-bottom-color: $--codelab-primary-black-1;
        background: transparent;
      }
    }
  }
  .title {
    font-size: 12px;
    color: #c8c8c8;
    line-height: 22px;
    padding: 0 14px;
  }
  .drop-item {
    font-size: 14px;
    color: #c8c8c8;
    line-height: 32px;
    
    padding: 0 14px;
    &:hover,
    :active {
      color: $--codelab-primary-blue-1;
      background: #333333;
    }
  }
}
</style>
